import { translate } from '@/domains/core/localization/translate';
export const {
  title,
  listItem1,
  listItem2,
  listItem3,
  text,
  cta,
  ctaReject,
  ctaBlindness
} = translate({
  "title": "Are you a Pro? Then you've come to the right place for your business!",
  "listItem1": "> 1M products delivered wherever you want",
  "listItem2": "Dedicated Pro advisors who are readily available",
  "listItem3": "simplified invoice management",
  "text": "Join ManoManoPro for free to save time and money.",
  "cta": "Create a Pro account",
  "ctaReject": "No thanks",
  "ctaBlindness": "Login"
});